import { RegistrationFacade } from '../../facades/registration_facade';
import { RegistrationSelectedSectionsQuery } from '../../queries/registration_selected_sections_query';

class RegistrationFriendlyReminderDialog {
  constructor(
    private ngRegistrationSelectedSectionsQuery: RegistrationSelectedSectionsQuery,
    private ngRegistrationFacade: RegistrationFacade
  ) {}

  closeFriendlyReminderPrompt($event: CustomEvent) {
    if (!$event.detail.value) {
      this.ngRegistrationFacade.closeFriendlyReminderPrompt();
      return;
    }
    this.ngRegistrationFacade.openFriendlyReminderPrompt();
  }
}

angular.module('capability-ng-scheduler').component('registrationFriendlyReminderDialog', {
  templateUrl:
    'capability-ng-scheduler/src/views/registration/components/registration_friendly_reminder_dialog/registration_friendly_reminder_dialog.html',
  controller: RegistrationFriendlyReminderDialog
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_friendly_reminder_dialog/registration_friendly_reminder_dialog.ts